import { ApiLoadingService } from './api-loading.service';
import { Injectable } from '@angular/core';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { environment } from './../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import { LocaleService } from './../seo/locale.service'

import { FormError, ApiError } from './../models/index';

@Injectable()
export class ApiCallService {
  callsInProgress: number = 0;

  constructor(
    private http: Http,
    private localeService: LocaleService,
    private apiLoadingService: ApiLoadingService
  ) {
  }

  getBasePath(): string {
    return environment.baseApiPath + '/agencies/' + environment.agency_uuid;
  }

  getRequestOptions(): RequestOptions {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept-Language', this.localeService.getCurrentLocale());
    return new RequestOptions({headers: headers});
  }

  getSeachUrlParams(searchParams: any, sort?: string, page?: number): string {
    let first = true;
    let path = '';

    for (const field in searchParams) {
      if (searchParams.hasOwnProperty(field)) {
        if (searchParams[field] !== null && searchParams[field] !== undefined && searchParams[field]) {
          if (Array.isArray(searchParams[field])) {
            searchParams[field].forEach(search => {
              path += (first ? '?' : '&') + field + '[]=' + search;
              first = false;
            });
          } else {
            path += (first ? '?' : '&') + field + '=' + searchParams[field];
            first = false;
          }
        }
      }
    }

    if (page) {
      path += (first ? '?' : '&') + 'page=' + page;
    }

    if (sort) {
      path += (first ? '?' : '&') + 'sort=' + sort;
      first = false;
    }

    return path;
  }

  startApiCall(): void {
    this.callsInProgress++;

    if (this.callsInProgress === 1) {
      this.apiLoadingService.startLoading();
    }
  }

  finishApiCall(): void {
    this.callsInProgress--;

    if (this.callsInProgress < 0) {
      this.callsInProgress = 0;
    }

    if (this.callsInProgress === 0) {
      this.apiLoadingService.stopLoading();
    }
  }

  // Standard HTTP requests
  get(path: string, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .get(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  post(path: string, data: any, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .post(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  put(path: string, data: any, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .put(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  delete(path: string, data?: any, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .delete(environment.apiUrl + '/' + basePath + path, { body: data })
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  patch(path: string, data: any, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .patch(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  head(path: string, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .head(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  options(path: string, basePath?: string): Promise<any> {
    if (basePath === undefined) {
      basePath = this.getBasePath();
    }

    this.startApiCall();

    return this.http
      .options(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
      .toPromise()
      .then(response => this.handleResponse(response))
      .catch(response => this.handleError(response));
  }

  handleResponse(response: Response): any {
    this.finishApiCall();

    if (response.status === 204) {
      return null;
    }
    return response.json();
  }

  handleError(errorResponse: Response): void {
    let error;

    this.finishApiCall();

    if (errorResponse.status === 400 || errorResponse.status === 422) {
      error = new FormError();
    } else {
      error = new ApiError();
    }

    error.code = errorResponse.status;
    error.message = errorResponse.statusText ? errorResponse.statusText : errorResponse;
    if (errorResponse.json) {
      error.errors = errorResponse.json().errors;
    }
    error.api_raw_response = errorResponse;

    console.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/api-call.service.ts